import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['indicatorIdInput', 'reportIdInput', 'valueInput', 'reportIndicatorIdInput', 'unitLabel']

  static values = {
    indicatorDetail: String
  }

  connect() {
    this.updateUnitLabel()
    this.updateValue()
  }

  updateValue() {
    const selectedReportIndicator = this.selectedReportIndicator()

    if (selectedReportIndicator) {
      this.valueInputTarget.value = selectedReportIndicator.value
      this.reportIndicatorIdInputTarget.value = selectedReportIndicator.report_indicator_id
    } else {
      this.valueInputTarget.value = ''
      this.reportIndicatorIdInputTarget.value = ''
    }
  }

  updateUnitLabel() {
    const selectedIndicator = this.selectedIndicator()

    if (selectedIndicator) {
      this.addUnitInInput(selectedIndicator.unit)
    } else {
      this.addUnitInInput(null)
    }
  }

  addUnitInInput(unit) {
    this.removeUnitInInput()

    if (unit) {
      this.unitLabelTarget.innerHTML = unit
    }
  }

  removeUnitInInput() {
    this.unitLabelTarget.innerHTML = ''
  }

  selectedReportIndicator() {
    const indicatorDetails = JSON.parse(this.indicatorDetailValue)
    const reportId = this.reportIdInputTarget.value
    const indicatorId = this.indicatorIdInputTarget.value

    const result = indicatorDetails.filter(
      detail => detail.report_id == reportId && detail.indicator_id == indicatorId
    )[0]

    return result
  }

  selectedIndicator() {
    const indicatorDetails = JSON.parse(this.indicatorDetailValue)
    const indicatorId = this.indicatorIdInputTarget.value

    const result = indicatorDetails.filter(detail => detail.indicator_id == indicatorId)[0]

    return result
  }
}
